const PageNotFound = () => {
  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "20px",
        color: "var(--mainText)",
        fontWeight: "500",
      }}
    >
      Страница не найдена
    </div>
  );
};

export default PageNotFound;
